import {
  ALLOWED,
  TRACK_DELIVERY
} from "@/app/infrastructures/misc/RolePermission";
import { FlagsDashboardCod } from "@/feature-flags/dashboard/cod";
import { FlagsPermissionDashboard } from "@/feature-flags/flags-dashboard";
import { FcsPermissionSttHanging } from "@/feature-flags/flags-permission-stt-hanging";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const Dashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/app/ui/views/dashboard/index.vue"
  );
const DashboardDetail = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/app/ui/views/dashboard/component/detail/index.vue"
  );
const DashboardDetailCourier = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/app/ui/views/dashboard/cod-dashboard/detail.vue"
  );
const PerformanceDelivery = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/app/ui/views/track-delivery/delivery-tab/index.vue"
  );

// Hanging
const HistoryIncoming = () =>
  import(
    /* webpackChunkName: "HistoryIncoming" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-incoming/index.vue"
  );
const TabHistoryHangingIncoming = () =>
  import(
    /* webpackChunkName: "TabHistoryHangingIncoming" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-incoming/tab-riwayat-hanging.vue"
  );
const TabHistoryFollowUpIncoming = () =>
  import(
    /* webpackChunkName: "TabHistoryFollowUpIncoming" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-incoming/tab-riwayat-follow-up.vue"
  );
const HistoryLastmile = () =>
  import(
    /* webpackChunkName: "HistoryLastmile" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-last-mile/index.vue"
  );
const TabHistoryHangingLastmile = () =>
  import(
    /* webpackChunkName: "TabHistoryHangingLastmile" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-last-mile/tab-riwayat-hanging.vue"
  );
const TabHistoryFollowUpLastmile = () =>
  import(
    /* webpackChunkName: "TabHistoryFollowUpLastmile" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-last-mile/tab-riwayat-follow-up.vue"
  );

const HistoryOutgoing = () =>
  import(
    /* webpackChunkName: "HistoryOutgoing" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-outgoing/index.vue"
  );
const TabHistoryHangingOutgoing = () =>
  import(
    /* webpackChunkName: "TabHistoryHangingOutgoing" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-outgoing/tab-riwayat-hanging.vue"
  );
const TabHistoryFollowUpOutgoing = () =>
  import(
    /* webpackChunkName: "TabHistoryFollowUpOutgoing" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-outgoing/tab-riwayat-follow-up.vue"
  );

const HistoryBkdConsole = () =>
  import(
    /* webpackChunkName: "HistoryBkdConsole" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-bkd/index.vue"
  );
const TabHistoryHangingBkdConsole = () =>
  import(
    /* webpackChunkName: "TabHistoryHangingBkdConsole" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-bkd/tab-riwayat-hanging.vue"
  );
const TabHistoryFollowUpBkdConsole = () =>
  import(
    /* webpackChunkName: "TabHistoryFollowUpBkdConsole" */ "@/app/ui/views/dashboard/component/console/hanging/page-riwayat-bkd/tab-riwayat-follow-up.vue"
  );

const HistoryBkdPos = () =>
  import(
    /* webpackChunkName: "HistoryBkdPos" */ "@/app/ui/views/dashboard/component/pos/hanging/page-riwayat-bkd/index.vue"
  );
const TabHistoryHangingBkdPos = () =>
  import(
    /* webpackChunkName: "TabHistoryHangingBkdPos" */ "@/app/ui/views/dashboard/component/pos/hanging/page-riwayat-bkd/tab-riwayat-hanging.vue"
  );
const TabHistoryFollowUpBkdPos = () =>
  import(
    /* webpackChunkName: "TabHistoryFollowUpBkdPos" */ "@/app/ui/views/dashboard/component/pos/hanging/page-riwayat-bkd/tab-riwayat-follow-up.vue"
  );

export default [
  {
    path: "/dashboard",
    component: Layout,
    name: "dashboard",
    meta: {
      header: true,
      icon: "home",
      children: false,
      title: "Dashboard",
      name: "Dashboard",
      gtmEventName: "dashboard_menu",
      gtmEventCustoms: {},
      gtmEventOption: ["userId", "userType", "timestamp"],
      permission: FlagsPermissionDashboard.dashboard_enable
    },
    children: [
      {
        path: "",
        name: "dashboard",
        component: Dashboard,
        meta: {
          header: true
        }
      },
      {
        path: "detail",
        name: "dashboard-detail",
        component: DashboardDetail,
        meta: {
          header: false,
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      header: true,
      hidden: true,
      parent: "Dashboard",
      permission: FlagsDashboardCod.permission_detail_cod_dashboard
    },
    children: [
      {
        path: ":id/detail-courier",
        name: "Detail Courier",
        component: DashboardDetailCourier,
        meta: {
          header: true,
          title: "COD Dashboard | Detail Courier",
          name: "Detail Courier",
          before: "/dashboard"
        }
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    name: "performa-pengiriman",
    meta: {
      hidden: true,
      parent: "Halaman Utama"
    },
    children: [
      {
        path: ":id",
        name: "performa-pengiriman",
        component: PerformanceDelivery,
        meta: {
          title: "Performa Pengiriman",
          customPath: true,
          header: true,
          isAuth: true,
          permission: TRACK_DELIVERY.ENABLE
        }
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    name: "performa-pengiriman",
    meta: {
      hidden: true,
      parent: "Halaman Utama"
    },
    children: [
      {
        path: ":id",
        name: "performa-pengiriman",
        component: PerformanceDelivery,
        meta: {
          title: "Performa Pengiriman",
          customPath: true,
          header: true,
          isAuth: true,
          permission: TRACK_DELIVERY.ENABLE
        }
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      header: true,
      hidden: true,
      parent: "Dashboard"
    },
    children: [
      {
        path: "",
        name: "history-incoming",
        component: HistoryIncoming,
        meta: {
          hidden: true,
          header: true,
          permission: ALLOWED,
          parent: "",
          name: "dashboard.hanging.historyIncomingTitle",
          title: "dashboard.hanging.historyIncomingTitle",
          before: "/"
        },
        children: [
          {
            path: "history-hanging-incoming",
            name: "history-hanging-incoming",
            component: TabHistoryHangingIncoming,
            meta: {
              header: true,
              tab: "history-hanging-incoming",
              permission: ALLOWED
            }
          },
          {
            path: "history-follow-up-incoming",
            name: "history-follow-up-incoming",
            component: TabHistoryFollowUpIncoming,
            meta: {
              header: true,
              tab: "history-follow-up-incoming",
              permission: ALLOWED
            }
          }
        ]
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      header: true,
      hidden: true,
      parent: "Dashboard"
    },
    children: [
      {
        path: "",
        name: "history-lastmile",
        component: HistoryLastmile,
        meta: {
          hidden: true,
          header: true,
          permission: ALLOWED,
          parent: "",
          name: "dashboard.hanging.historyLastMileTitle",
          title: "dashboard.hanging.historyLastMileTitle",
          before: "/"
        },
        children: [
          {
            path: "history-hanging-lastmile",
            name: "history-hanging-lastmile",
            component: TabHistoryHangingLastmile,
            meta: {
              header: true,
              tab: "history-hanging-lastmile",
              permission: ALLOWED
            }
          },
          {
            path: "history-follow-up-lastmile",
            name: "history-follow-up-lastmile",
            component: TabHistoryFollowUpLastmile,
            meta: {
              header: true,
              tab: "history-follow-up-lastmile",
              permission: ALLOWED
            }
          }
        ]
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      hidden: true,
      parent: "Dashboard"
    },
    children: [
      {
        path: "",
        name: "history-outgoing",
        component: HistoryOutgoing,
        meta: {
          layoutNoPadding: true,
          hidden: true,
          header: false,
          permission:
            FcsPermissionSttHanging.permission_hanging_outgoing_enable,
          parent: "",
          name: "dashboard.hanging.historyOutgoingTitle",
          title: "dashboard.hanging.historyOutgoingTitle",
          before: "/"
        },
        children: [
          {
            path: "history-hanging-outgoing",
            name: "history-hanging-outgoing",
            component: TabHistoryHangingOutgoing,
            meta: {
              tab: "history-hanging-outgoing",
              permission:
                FcsPermissionSttHanging.permission_hanging_outgoing_enable
            }
          },
          {
            path: "history-follow-up-outgoing",
            name: "history-follow-up-outgoing",
            component: TabHistoryFollowUpOutgoing,
            meta: {
              tab: "history-follow-up-outgoing",
              permission:
                FcsPermissionSttHanging.permission_hanging_outgoing_enable
            }
          }
        ]
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      hidden: true,
      parent: "Dashboard"
    },
    children: [
      {
        path: "",
        name: "history-bkd-console",
        component: HistoryBkdConsole,
        meta: {
          layoutNoPadding: true,
          hidden: true,
          header: true,
          permission:
            FcsPermissionSttHanging.permission_hanging_bkd_console_enable,
          parent: "",
          name: "dashboard.hanging.historyBkdConsoleTitle",
          title: "dashboard.hanging.historyBkdConsoleTitle",
          before: "/"
        },
        children: [
          {
            path: "history-hanging-bkd-console",
            name: "history-hanging-bkd-console",
            component: TabHistoryHangingBkdConsole,
            meta: {
              tab: "history-hanging-bkd-console",
              permission:
                FcsPermissionSttHanging.permission_hanging_bkd_console_enable
            }
          },
          {
            path: "history-follow-up-bkd-console",
            name: "history-follow-up-bkd-console",
            component: TabHistoryFollowUpBkdConsole,
            meta: {
              tab: "history-follow-up-bkd-console",
              permission:
                FcsPermissionSttHanging.permission_hanging_bkd_console_enable
            }
          }
        ]
      }
    ]
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: {
      hidden: true,
      parent: "Dashboard"
    },
    children: [
      {
        path: "",
        name: "history-bkd-pos",
        component: HistoryBkdPos,
        meta: {
          layoutNoPadding: true,
          hidden: true,
          header: false,
          permission: FcsPermissionSttHanging.permission_hanging_bkd_pos_enable,
          parent: "",
          name: "dashboard.hanging.historyBkdPosTitle",
          title: "dashboard.hanging.historyBkdPosTitle",
          before: "/"
        },
        children: [
          {
            path: "history-hanging-bkd-pos",
            name: "history-hanging-bkd-pos",
            component: TabHistoryHangingBkdPos,
            meta: {
              tab: "history-hanging-bkd-pos",
              permission:
                FcsPermissionSttHanging.permission_hanging_bkd_pos_enable
            }
          },
          {
            path: "history-follow-up-bkd-pos",
            name: "history-follow-up-bkd-pos",
            component: TabHistoryFollowUpBkdPos,
            meta: {
              tab: "history-follow-up-bkd-pos",
              permission:
                FcsPermissionSttHanging.permission_hanging_bkd_pos_enable
            }
          }
        ]
      }
    ]
  }
];
